import { render, staticRenderFns } from "./CustomerSurveyDataTable.vue?vue&type=template&id=137e2998&scoped=true"
import script from "./CustomerSurveyDataTable.vue?vue&type=script&lang=js"
export * from "./CustomerSurveyDataTable.vue?vue&type=script&lang=js"
import style0 from "./CustomerSurveyDataTable.vue?vue&type=style&index=0&id=137e2998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137e2998",
  null
  
)

export default component.exports